import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import './Navbar.css';

// Logo path - using static folder to work with existing Vercel routing
const logoPath = '/static/logo.png';

function Navbar() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      // Check if this is a password recovery session (temporary)
      // Don't show account link during password recovery
      const isPasswordRecovery = window.location.pathname === '/reset-password';
      
      if (session && !isPasswordRecovery) {
        setUser(session.user);
      } else {
        setUser(null);
      }
      
      setLoading(false);
    };

    checkUser();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        // Don't set user during password recovery flow
        const isPasswordRecovery = window.location.pathname === '/reset-password';
        if (session && !isPasswordRecovery) {
          setUser(session.user);
        } else if (!isPasswordRecovery) {
          setUser(null);
        }
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <nav className="navbar">
        <div className="navbar-content">
          <div></div>
          <div>Loading...</div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <a href="/" className="navbar-brand">
          <img 
            src={logoPath} 
            alt="Cart Scanners" 
            className="navbar-logo"
            onError={(e) => {
              console.error('Logo failed to load from:', e.target.src);
              console.error('Current location:', window.location.href);
              e.target.style.display = 'none';
            }}
          />
          <span>Cart Scanners</span>
        </a>
        <div className="navbar-links">
          {user ? (
            <>
              <a href="/products" className="navbar-link">Products</a>
              <a href="/account" className="navbar-link">Account</a>
            </>
          ) : (
            <a href="/signin" className="navbar-link">Log in</a>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

